// Library imports
import React from "react";
import { useTranslation } from "react-i18next";

// Meridian imports
import Button from "@amzn/meridian/button";
import Heading from "@amzn/meridian/heading";
import Icon from "@amzn/meridian/icon";
import Row from "@amzn/meridian/row";
import Tooltip from "@amzn/meridian/tooltip";
import flashTokens from "@amzn/meridian-tokens/base/icon/flash";
import helpTokens from "@amzn/meridian-tokens/base/icon/help";

// Local imports
import { keys } from "i18n/keys";

export default function Headers() {
  const { t } = useTranslation();

  return (
    <Row alignmentHorizontal="justify" data-testid="pageHeader">
      <Heading level={2} data-testid="pageHeaderTitle">
        Yard 360
      </Heading>

      <Row spacing="none" data-testid="pageHeaderButtons">
        <Tooltip position="bottom" title="Coming soon!" data-testid="whatsNewTooltip">
          <Button type="icon" disabled={true} data-testid="whatsNewButton">
            {t(keys.WHAT_IS_NEW)}
            <Icon tokens={flashTokens}>What Is New</Icon>
          </Button>
        </Tooltip>

        <Tooltip position="bottom" title="Coming soon!" data-testid="helpTooltip">
          <Button type="icon" disabled={true} data-testid="helpButton">
            {t(keys.HELP)}
            <Icon tokens={helpTokens}>Help</Icon>
          </Button>
        </Tooltip>
      </Row>
    </Row>
  );
}
